type OfficerLike = Readonly<{ code: string; label: string }>;

/**
 * Texto a mostrar para `officer` según catálogo de oficiales.
 * El BFF/MS puede devolver código ("001", "1") o el nombre ya resuelto (ej. "Carlos Saavedra").
 */
export function getOfficerDisplayLabel(
  officer: string | undefined | null,
  officers: ReadonlyArray<OfficerLike>,
): string {
  if (officer === undefined || officer === null) return '—';
  const trimmed = String(officer).trim();
  if (!trimmed || trimmed === '-') return '—';

  const byExactCode = officers.find((item) => item.code === trimmed);
  if (byExactCode) return byExactCode.label;

  if (/^\d+$/.test(trimmed)) {
    const padded = trimmed.padStart(3, '0');
    const byPadded = officers.find((item) => item.code === padded);
    if (byPadded) return byPadded.label;
  }

  const byLabel = officers.find((item) => item.label === trimmed);
  if (byLabel) return byLabel.label;

  return trimmed;
}
